<template>
  <div>

    <el-row>
      <el-col :span="6">
        <span class="dash-value dash-num-blue" style="margin-top: 20px">{{totalCount}}</span>&nbsp;
        <span class="dash-title">{{$t('listGroup.group')}}</span>&nbsp;
      </el-col>
      <el-col :span="18">
        <div class="searchBar">
          <slot><el-button type="primary" size="small" icon="el-icon-plus" @click="addRole">{{$t('listGroup.add')}}</el-button></slot>
        </div>
      </el-col>
    </el-row>

    
    <el-table :data="items" style="width: 100%;padding: 10px 10px 10px 10px;">
      <el-table-column prop="groupID" label="ID"></el-table-column>
      <el-table-column prop="groupName" :label="$t('listGroup.name')"></el-table-column>
      <el-table-column prop="processName" :label="$t('listGroup.bindprocess')"></el-table-column>
      <el-table-column :label="$t('listGroup.process')">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger" @click="confirmDelete(scope.row.groupID)" plain>{{$t('listGroup.remove')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { listGroup,removeGroup} from "@/api/admin";
import { mapState } from "vuex";
import { ROUTER_PATH } from "@/constants/common.js";

export default {
  name: "ListRole",
  data: () => {
    return {
      totalCount: 0,
      items: []
    };
  },
  mounted() {
    this.refreshData();
  },
  computed: {
    ...mapState(["accountInfo"])
  },
  methods: {
    refreshData() {
      listGroup({
        companyID: this.accountInfo.companyID
      }).then(response => {
        this.totalCount = response.data.totalCount;
        this.items = response.data.items;
      });
    },
    addRole(){
      this.$router.push(ROUTER_PATH.ADD_ROLE);
    },
    confirmDelete(rid) {
        this.$confirm(this.$t('listGroup.confirm'), this.$t('common.popup'), {
          confirmButtonText: this.$t('common.ok'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          removeGroup({
            groupID: rid
          }).then(response => {
            this.$message({
              type: 'success',
              message: response.message
            });
            this.refreshData();
          });
          
        }).catch(() => {
                  
        });
      }
  }
};
</script>
<style>
  .searchBar {
    margin: 0px 0px 10px 0px;
    /*padding: 10px 10px ;*/
    /*background-color: #f7f7f7;*/
    text-align: right;
  }
  </style>
